module.exports = __webpack_public_path__ + "static/fipclemonbravemain-4a34694b630227cddee1b6b1d4f9872a.jpeg";